import React from 'react'
import ReactDOM from 'react-dom'
import './index.less'
import MRouter from './routes'
import {Provider} from 'react-redux'
import store from './store'
import zhCN from 'antd/lib/locale/zh_CN'
import 'moment/locale/zh-cn'

import moment from 'moment'
import {ConfigProvider} from 'antd'
import {REFRESH_TOKEN, TOKEN, USER_INFO} from 'api/constants'
import {saveUser} from 'reducers/user'
import {setToken} from 'api/m-axios'

//pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/scripts/pdf.worker.js`
//https://cdn.bootcdn.net/ajax/libs/pdf.js/2.10.377/pdf.worker.js

moment.locale('zh-cn')

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={zhCN}>
      <MRouter />
    </ConfigProvider>
  </Provider>,
  document.getElementById('root')
)

window.addEventListener('beforeunload', e => {
  let user = store.getState().user
  if (user.user_id !== '') {
    sessionStorage.setItem(USER_INFO, JSON.stringify(user))
  }
  let currentGrade = store.getState().course.currentGrade
  if (currentGrade && currentGrade.id !== 0) {
    sessionStorage.setItem('CurrentGrade', JSON.stringify(currentGrade))
  }
})

window.addEventListener(
  'message',
  e => {
    if (e.origin === process.env.REACT_APP_ORIGIN_URL) {
      let data = e.data
      if (data.user && data.token && data.refresh_token) {
        sessionStorage.setItem(TOKEN, data.token)
        sessionStorage.setItem(REFRESH_TOKEN, data.refresh_token)
        setToken()
        store.dispatch(saveUser(data.user))
      }
    }
  },
  false
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
